import '../../../Modals/XpektorBootstrapModal.scss';
import { useState } from 'react';
import { Modal } from 'react-bootstrap';
import UserGroupService from '../../../../../Services/UserGroupService';
import UserService from '../../../../../Services/UserService';
import {
  XpektorForm,
  FormInput,
  FormButton,
} from '../../../../../Components/XpektorForms/XpektorForms';

const gT = (t, key) => t(`modal.create-user-group${key}`);
const gsT = (t, key) => t(`shared${key}`);

/* eslint-disable react/prop-types */
export default function CreateUserGroupModal({
  onGroupCreated,
  handleClose,
  t,
}) {
  const [groupName, setGroupName] = useState('');
  const [errorText, setErrorText] = useState('');
  const [creating, setCreating] = useState(false);
  const createGroup = async (e) => {
    e.preventDefault();

    const tmpGroupName = groupName.trim();

    if (tmpGroupName.length === 0) {
      setErrorText(gsT(t, '.errors.empty-field'));
      return;
    }

    setCreating(true);
    const user = UserService.getCurrentUser();

    await UserGroupService.createUserGroup(user.customerId, tmpGroupName)
      .then(() => {
        onGroupCreated();
        handleClose();
      })
      .catch((error) => {
        switch (error.response.status) {
          case 400:
            setErrorText(gT(t, '.error.name-in-use'));
            break;
          default:
            setErrorText(gT(t, '.error.general'));
            break;
        }
      })
      .finally(() => {
        setCreating(false);
      });
  };
  return (
    <Modal
      show
      onHide={handleClose}
      backdrop="static"
      centered
      keyboard={false}
      className="border-0 xpektor-bootstrap-modal"
    >
      <Modal.Header closeButton>
        <Modal.Title>{gT(t, '.modal-title')}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <XpektorForm onSubmit={createGroup}>
          <FormInput
            label={gT(t, '.label')}
            value={groupName}
            onChange={(e) => setGroupName(e.target.value)}
            infoText={errorText}
          />
          <FormButton text={gT(t, '.text')} disabled={creating} />
        </XpektorForm>
      </Modal.Body>
    </Modal>
  );
}
